import {useCallback, useEffect} from 'react';
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types';
import { Container, Hidden, IconButton } from '@material-ui/core';

import useLocalized from 'CustomHooks/useLocalized';
import BackgroundImage from 'UI/Screens/Main/Sections/Header/Assets/HeaderBackground.png'
import BookDriverForm from 'UI/Screens/Main/Sections/Header/Blocks/BookDriverForm/BookDriverForm';
import ScrollDownIcon from 'UI/Screens/Main/Sections/Header/Components/ScrollDownIcon/ScrollDownIcon';
import { NAVIGATION_SECTION_IDS } from 'Constants/NavigationConstants';
import {useGetHomeContent} from "../../../../../Data/ApiHooks/UseContentHook";
import {BASE_URL} from "../../../../../Constants/Options";

const Header = ({
  branchLocationOptions,
}) => {
  const history = useHistory();
  const handleScroll = useCallback(() => {
    history.push(`/#${NAVIGATION_SECTION_IDS.aboutUs}`)
  }, [history]);

  const { data } = useGetHomeContent();

  return (
    <>
      <div style={{ backgroundImage: `url(${BASE_URL + data?.hero_image})` }} className="header-section-top">
        <Container>
          <div className="header-section">
            <div className="header-section__left">
              <div className="title">
                { data?.slogan_title }
              </div>
              <div className="line" />
              <div className="description">
                { data?.slogan_description }
              </div>
            </div>
            <Hidden smDown>
              <div className="header-section__rigth">
                <BookDriverForm className="header-section__rigth--form" branchLocationOptions={branchLocationOptions} />
              </div>
            </Hidden>
            <IconButton onClick={handleScroll} className="header-section__button">
              <ScrollDownIcon />
            </IconButton>
          </div>
        </Container>
      </div>
      <Hidden mdUp>
        <Container>
          <BookDriverForm className="header-section__rigth--form" branchLocationOptions={branchLocationOptions} />
        </Container>
      </Hidden>
    </>
  )
}

Header.propTypes = {
  branchLocationOptions: PropTypes.object,
};

export default Header;
